import { Space, Badge } from 'antd';
import { useConversationUnreplyCustomer } from 'hooks/business/conversation';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { formatNumber } from 'utils/numberFormat';
import { useReceptionBuyer } from 'hooks/business/receptionBuyerStat';

export const ChatNav = () => {
  const { t } = useTranslate();
  const receptionBuyer = useReceptionBuyer();
  const conversationUnreplyCustomer = useConversationUnreplyCustomer();
  // const setConversationUnreplyCustomer = useSetConversationUnreplyCustomer();

  // const { run, cancel } = useRequest(
  //   () => fetchReceptioinBuyerInfo().then(() => setConversationUnreplyCustomer(0)),
  //   {
  //     pollingInterval: 15 * 1000,
  //     manual: true,
  //     onError: noop,
  //   },
  // );

  // useEffect(() => {
  //   if (online) {
  //     run();
  //   } else {
  //     cancel();
  //   }

  //   return () => {
  //     cancel();
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [online]);

  const chatCount = useMemo(() => {
    const todayUnreplyNum = receptionBuyer.untreatedCount + conversationUnreplyCustomer;
    return formatNumber(todayUnreplyNum < 0 ? 0 : todayUnreplyNum);
  }, [conversationUnreplyCustomer, receptionBuyer.untreatedCount]);

  return (
    <Space>
      {t('header.会话')}
      <Badge count={chatCount} overflowCount={9999} style={{ background: '#165DFF' }} />
    </Space>
  );
};
